import React from 'react';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import AlertModal from '../../../../components/Modal/templates/AlertModal';
import { Button, ButtonVariant, CancelButton } from '../../../../components/Button';

interface DeleteKitTemplateModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  loading: boolean;

  remove: () => Promise<void>;
}

export default function DeleteKitTemplateModal({ open, setOpen, remove, loading }: DeleteKitTemplateModalProps) {
  return (
    <AlertModal title={t(TranslationKey.kitTemplateDeleteTitle).singular.upper} open={open} setOpen={setOpen}>
      <div className='grid gap-4'>
        <p className='subtitle'>{t(TranslationKey.kitTemplateDeleteSubtitle).singular.upper}</p>
        <div className='flex justify-end gap-2'>
          <CancelButton onClick={() => setOpen(false)} disabled={loading} />
          <Button
            variant={ButtonVariant.danger}
            text={t(TranslationKey.kitTemplateDelete).singular.upper}
            onClick={() => remove()}
            loading={loading}
          />
        </div>
      </div>
    </AlertModal>
  );
}
